import { Box, Container, Typography } from '@material-ui/core'

import outreachEmptyState from './empty-state.jpeg'

export const EmptyState = () => {
  return (
    <Container maxWidth="md">
      <Box textAlign="center">
        <Box mb={2}>
          <Typography variant="h3">Get Started with Outreach Messages to Connect with Students and Parents</Typography>
        </Box>
        <Typography
          variant="body1"
          paragraph
        >
          Create automated and one time messages to send to students and parents that are interested in your school.
        </Typography>
        <Typography
          variant="body1"
          paragraph
        >
          <a href="https://scoir.helpdocs.io/article/6fejrfngu7-outreach-messages">
            See our Help and Support Pages for more how-to information.
          </a>
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        p={2}
      >
        <img
          height={200}
          alt=""
          src={outreachEmptyState}
        />
      </Box>
    </Container>
  )
}

export default EmptyState
